<template>
  <v-dialog :value="value" @input="handleDialogInput" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ routemap.name }} - {{ routemap.quantity }} {{ $t("COUNT_ABBREVIATION") }} /
        {{ routemap.hallNames }}
      </v-card-title>

      <v-card-text>
        <ErrorMessages :errorMessages="localErrorMessages" />

        <v-row>
          <h4>
            {{ $t("OPERATOR") }}:
            <strong>
              {{ editedOperation.operator }}
            </strong>
          </h4>

          <v-col class="col-12">
            {{ $t("OPERATION") }}
            <select v-model="form.operationId" type="text" class="form-control">
              <option disabled v-bind:value="0">{{ $t("CHOOSE") }}</option>
              <option
                v-for="operation in routemap.productOperations"
                v-bind:key="operation.id"
                v-bind:value="operation.id"
              >
                {{ operation.name }}</option
              >
            </select>
          </v-col>
          <v-col class="col-12">
            {{ $t("COUNT") }}
            <input v-model="form.quantity" type="text" class="form-control" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="handleSaveClicked()">
          {{ $t("EDIT") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessages from "@/components/ErrorMessages";

export default {
  components: {
    ErrorMessages
  },

  props: {
    routemap: {
      required: true,
      type: Object
    },

    editedOperation: {
      required: true,
      type: Object
    },

    value: {
      required: true,
      type: Boolean
    },

    errorMessages: {
      default: () => {}
    }
  },

  data() {
    return {
      form: {
        id: this.editedOperation.id,
        routeMapId: this.routemap.id,
        operatorId: this.editedOperation.operatorId,
        operationId: this.editedOperation.operationId,
        quantity: this.editedOperation.quantity
      },
      localErrorMessages: {}
    };
  },

  watch: {
    value() {
      this.clearForm();
    },

    errorMessages() {
      this.localErrorMessages = this.errorMessages;
    }
  },

  methods: {
    handleSaveClicked() {
      if (this.form.operationId < 1) {
        this.localErrorMessages = {
          0: [this.$t("PLEASE_CHOOSE_OPERATION")]
        };

        return;
      }

      if (this.form.quantity < 1) {
        this.localErrorMessages = {
          0: [this.$t("THE_NUMBER_OF_PERFORMED_OPERATIONS_MUST_BE_AT_LEAST_1")]
        };

        return;
      }

      this.$emit("save-clicked", this.form);
    },

    handleDialogInput(value) {
      this.clearForm();

      this.$emit("input", value);
    },

    clearForm() {
      this.form = {
        id: this.editedOperation.id,
        routeMapId: this.routemap.id,
        operatorId: this.editedOperation.operatorId,
        operationId: this.editedOperation.operationId,
        quantity: this.editedOperation.quantity
      };

      this.localErrorMessages = {};
    }
  }
};
</script>
